// extracted by mini-css-extract-plugin
export default {"question":"Question_question__EIWuE","qtitle":"Question_qtitle__3fVXl"};